import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=480f34c6&"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('480f34c6')) {
      api.createRecord('480f34c6', component.options)
    } else {
      api.reload('480f34c6', component.options)
    }
    module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=480f34c6&", function () {
      api.rerender('480f34c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "themes/betsur/modules/components/layout/LanguageSwitcher.vue"
export default component.exports